import InputWrapper from "./components/InputWrapper";
import ReCaptcha from "../components/ReCaptcha";
import { Link } from "react-router-dom";
import GoBack from "./components/GoBack";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from "react";
import Meta from "../components/Meta";
import Data from "./Data";
import { forgottenPasswordSchema } from '../../validation/schemas';

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false)
    const [success, setSuccess] = useState(false)
    const [recaptchaToken, setRecaptchaToken] = useState(null);

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(forgottenPasswordSchema),
        defaultValues: {
            email: ''
        }
    })

    const submit = async (data) => {
        // Validate reCAPTCHA
        if (process.env.REACT_APP_RECAPTCHA_ENABLED === 'true' && !recaptchaToken) {
            setError(true);
            setSuccess(false);
            return;
        }

        setLoading(true)
        setSuccess(false)

        try {
            await Data.forgotPassword(data.email, recaptchaToken)

            setLoading(false)
            setError(false)
            setSuccess(true)
            setRecaptchaToken(null);
        } catch (error) {
            console.log(error)
            setLoading(false)
            setError(true)
            setSuccess(false)
            setRecaptchaToken(null);
        }
    }

    return (
        <>
            <Meta title={'Forgot Password'} />
            <GoBack to={"/"} label={"Back to Home"} />
            {!success ?
                <form className={"w-96 mx-auto py-40 px-4 grid grid-cols-1 gap-4 rounded-lg"} onSubmit={handleSubmit(submit)}>
                    <h1>Forgot Password</h1>
                    <InputWrapper label={"Email Address"} input={<input type={"text"} {...register("email")} />} error={errors.email?.message} />
                    <ReCaptcha
                        onChange={(token) => {
                            setRecaptchaToken(token);
                            if (token) setError(false);
                        }}
                        onExpired={() => setRecaptchaToken(null)}
                    />
                    <button type={"submit"} disabled={loading}
                        className={"inline-block bg-primary py-2 px-4 w-full lg:w-auto text-white text-center rounded-md mt-2 border-0"}>{loading ? '...' : 'Request Password Reset'}</button>
                    {error && <p className={"text-red-500"}>Please complete the reCAPTCHA verification and try again.</p>}
                    <Link className={"text-sm text-textGrey"} to={"/login"}>Remember your password?</Link>
                </form>
                :
                <div className={"w-96 mx-auto py-40 px-4 grid grid-cols-1 gap-4 rounded-lg"}>
                    <h1>Forgot Password</h1>
                    <p className={"text-textGrey"}>We have sent you an email with instructions on how to reset your password.</p>
                    <Link className={"inline-block bg-primary py-2 px-4 w-full lg:w-auto text-white text-center rounded-md mt-2 border-0"} to={"/login"}>Login</Link>
                </div>
            }
        </>
    )
}

export default ForgotPassword
